const prefix = process.env.VUE_APP_API_URL

export const loginAPI = prefix + 'auth/login'
export const confirmLoginAPI = prefix + 'auth/confirm-login'
export const loginWithNumberAPI = prefix + 'auth/login-with-number'
export const confirmLoginWithNumberAPI = prefix + 'auth/confirm-login-with-number'
export const logoutAPI = prefix + 'auth/logout'
export const refreshTokenAPI = prefix + 'auth/test-token'
export const myProfileAPI = prefix + 'auth/my-profile'
export const firstPracticedAPI = prefix + 'auth/first-practice'
export const fullfillDataAPI = prefix + 'auth/fullfill-data'
export const updateAPI = prefix + 'auth/update-data'
export const updateWithPasswordAPI = prefix + 'auth/update-data-password'
export const getAvatarAPI = prefix + 'auth/get-avatar'
export const getOSSAuth = prefix + 'auth/get-resource-auth'
export const forgetNumberEmail = prefix + 'auth/forget-number-email/'
export const forgetNumberxEmail = prefix + 'auth/forget-number-xemail/'
export const numberToVendorInfo = prefix + 'auth/number-to-vendor/'
export const contactAPI = prefix + 'auth/submit-contact/'
export const forgetPassword = prefix + 'auth/forget-password/'
export const forgetPasswordTry = prefix + 'auth/reset-try/'
export const resetPassword = prefix + 'auth/reset-password/'
